export default "__VITE_ASSET__6a28429c__"